import { Delete, Get, getAPIUrl, Post } from "../../../../services/apiMethod";

export const ColourEndpoints = {
  getColorDetails: `/admin/getColors?`,
  addColor: `/admin/addColor`,
  deleteColour: `/admin/deleteColor?id=`,
};

export const getColorDetails = (param = "") => {
  const url = getAPIUrl(ColourEndpoints.getColorDetails, param);
  return Get(url);
};
export const addColor = (data, param = "") => {
  const url = getAPIUrl(ColourEndpoints.addColor, param);
  return Post(url, data);
};
export const deleteColour = (param = "") => {
  const url = getAPIUrl(ColourEndpoints.deleteColour, param);
  return Delete(url, param);
};
